import Donor from "./models/Donor"
import { ObservableFromFetch } from "./ObservableFromFetch"

export const getDonorInfo = () => ObservableFromFetch<Donor>("Results/DonorInfo")
